<template>
	<div class="sa_container">
        <div class="title">用户协议</div>
        <pre class="content">
更新日期：2026年06月20日
生效日期：2026年06月20日
欢迎您使用ShunFeng软件及服务！
ShunFeng（以下简称“产品”）是一款由顺峰互动（以下简称“公司”）提供服务的社交产品。为使用ShunFeng软件（以下统称“本软件”）及服务，您应当仔细阅读并遵守《ShunFeng用户协议》（以下简称“本协议”），以及《ShunFeng隐私政策》请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，对用户权利进行限制的条款、约定争议解决方式和司法管辖的条款等，并选择接受或不接受。限制、免责条款或者其他涉及您重大权益的条款可能以加粗、加下划线等形式提示您重点阅读并注意。
为了更好地为您提供服务，请您在开始使用ShunFeng软件及其相关服务之前，认真且充分阅读、完全理解透彻并接受本协议所有条款，否则您无权注册、登录或使用本软件及相关服务。您进行注册、登录、使用ShunFeng等行为默示表示您已阅读并同意本协议的各项条款约束。本协议即在您与公司之间产生法律效力，成为对双方均具有约束力的法律文件。
如果您因智力、年龄等因素而不具有完全民事行为能力，请在法定监护人（以下简称“监护人”）的陪同下阅读和判断是否同意本协议。
您订立或履行本协议以及使用本服务的行为还需要同时遵守您所属和所处国家或地区的法律。
如果违反本协议内容条款，我们保留依据法律条款追求此类违规行为的权力。
一、协议的范围
1.1 本协议是您与公司之间关于您下载、安装、使用、复制、注册、登录本软件，以及使用公司相关服务所订立的协议。
1.2 本协议的内容，包括但不限于以下与本软件和本服务相关的协议、规则、规范以及公司可能不断发布的关于本软件和本服务的相关协议、规则、规范等内容。前述内容一经正式发布，即为本协议不可分割的组成部分，与其构成统一整体，您同样应当遵守。
二、关于本服务
2.1本服务的内容
2.1.1本服务的内容是指公司向用户提供的跨平台的通讯工具（以下简称“ShunFeng”），支持单人、多人参与，在发送语音信息、图片、视频、文字和表情等即时通讯服务的基础上，同时为用户提供包括但不限于关系链拓展、便捷工具、与其他软件或硬件信息互通等功能或内容的软件许可及服务（以下简称“本服务”）。
2.1.2您知晓并同意，公司可能会根据需要更新或调整本软件和本服务的内容，公司可随时修改、更新、中断、暂停或终止服务，无需另行通知或承担任何责任。
2.2本服务的形式
2.2.1 您使用本服务需下载ShunFeng客户端软件，对于软件，公司给予您一项个人的、可撤销的、不可转让及非排他性的许可。
2.2.2 本服务中ShunFeng客户端软件可能提供包括但不限于iOS、Android、Windows Phone、Symbian、BlackBerry、Windows、Mac等多个应用版本，用户必须选择与所安装终端设备相匹配的软件版本。
2.3 本服务许可的范围
2.3.1 对于使用本软件，公司给予您一项个人的、可撤销的、不可转让及非排他性的许可。您可以为非商业目的在单一台终端设备上安装、使用、显示、运行本软件。
2.3.2 您可以为使用本软件及服务的目的复制本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息。
2.3.3 本条及本协议其他条款未明示授权的其他一切权利仍由公司保留，您在行使这些权利时须另外取得公司的书面许可。公司如果未行使前述任何权利，并不构成对该权利的放弃。
三、账号使用规范
3.1使用本软件前您需要通过邮箱地址注册一个ShunFeng用户账号，公司有权根据用户需求或产品需要对账号注册方式进行变更。
3.2ShunFeng账号的所有权归公司所有，用户完成申请注册手续后，仅获得ShunFeng账号的使用权，且该使用权仅属于初始申请注册人。同时，初始申请注册人不得赠与、借用、租用、转让或售卖ShunFeng账号或者以其他方式许可非初始申请注册人使用ShunFeng账号。非初始申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用ShunFeng账号。
3.3用户有责任妥善保管注册账户信息及账户密码的安全，用户需要对注册账户以及密码下的行为承担法律责任。用户同意在任何情况下不向他人透露账户及密码信息。当在您怀疑他人在使用您的账号时，您应立即通知公司。
3.4用户在使用邮箱地址注册ShunFeng账号时，系统将为您自动匹配ShunFeng号，您的ShunFeng号不能设置和修改。
3.5用户注册或创建ShunFeng账号后如果长期不登录该账号，公司有权回收该账号，以免造成资源浪费，由此带来的任何损失均由用户自行承担。
3.6在需要终止使用ShunFeng账号服务时，您可以申请销毁您的ShunFeng账号：
（1）您仅能申请销毁您本人的账号，并依照ShunFeng的流程进行销毁；
（2）您仍应对您在销毁账号前且使用ShunFeng服务期间的行为承担相应责任；
（3）销毁成功后，账号记录、功能等将无法恢复或提供。
如您需要销毁您的ShunFeng账号，请打开ShunFeng客户端，在【我】-【设置】-【销毁账号】按提示进行销毁。
四、软件的获取
4.1 您可以直接从ShunFeng官方网站、官方应用分发平台以及公司授权的第三方网站、应用分发平台等公司官方或公司授权的渠道获取本软件。
4.2如果您从未经公司授权的第三方获取本软件或与本软件名称相同的安装程序，公司无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。
五、软件的安装与卸载
5.1公司可能为不同的终端设备开发不同的应用程序软件版本，您应当根据实际设备状况获取、下载、安装合适的版本。
5.2下载安装程序后，您需要按照该程序提示的步骤正确安装。
5.3因经营策略安排或调整等原因，不同地区的用户于本软件可使用的具体服务内容可能会存在差异，具体以公司实际提供的为准。
5.4您可根据需要自行使用ShunFeng软件及相关服务或更新ShunFeng版本，如您不再需要使用ShunFeng软件及相关服务，您也可自行卸载相应的应用程序软件。
六、软件的更新
6.1为了改善用户体验、完善服务内容，公司将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。
6.2 为了改善用户体验或提高服务安全性、保证功能的一致性等目的，公司有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。
6.3 本软件新版本发布后，旧版本的软件可能无法使用。公司不保证旧版本软件继续可用，也不保证继续对旧版本软件提供相应的客服和维护服务，请您随时核对并下载最新版本。
七、用户个人信息保护
7.1保护用户个人信息是公司的一项基本原则，公司将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可公司不会向第三方公开、透露用户个人信息。公司对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。
7.2您在注册账号或使用本服务的过程中，需要提供一些必要的信息，例如：为向您提供账号注册服务，需要您填写邮箱地址；为维护ShunFeng社交环境的真实性需要包括您在内的所有用户提供真实的身份信息；基于地理位置信息推荐新用户需要您同意使用您所在的地理位置信息等。若国家法律法规（本协议中的“法律法规”指用户所属/所处地区、国家现行有效的法律、行政法规、司法解释、地方性法规、地方规章、部门规章及其他规范性文件以及对于该等法律法规的不时修改和补充，以及相关政策规定等，下同。）有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。
7.3 一般情况下，您可根据相关产品规则浏随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。
7.4 为增加用户使用本服务的娱乐性，促进用户之间的沟通和交流，改善、优化相应服务，公司会对您的昵称、头像以及在本软件中的相关操作等信息进行使用。
7.5公司将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。
7.6未经您的同意，公司不会将您的个人信息转移或披露给任何第三方，除非：
（1）相关法律法规或司法机关、行政机关要求；或
（2）为完成合并、分立、收购或资产转让而转移；或
（3）为提供您要求的服务所必需。
7.7如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。
7.8对于ShunFeng会如何收集、使用、存储和保护您的个人信息及您享有何种权利，您还可以阅读《ShunFeng隐私政策》予以进一步了解。
八、用户行为规范
8.1用户注意事项
您充分理解并同意：
8.1.1为了向您提供有效的服务，本软件会利用您终端设备的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。
8.1.2本软件的某些功能可能会让第三方知晓用户的信息，本软件的某些功能可能会让第三方知晓用户的信息，例如：您可能会被推荐给其他ShunFeng用户，其他ShunFeng用户可以查询您提交的可公开的个人资料（包括但不限于头像、昵称、ShunFeng账号、性别等信息）；为了方便好友与您进行语音通话或视频聊天，会获取并展示您的设备信息、网络状态等；您应了解本部分的信息公开和透露可能会给您带来潜在风险，并自行承担由此造成的风险。
8.1.3您在使用本服务某一特定功能时，公司可以使用您终端设备的相关权限、接口及相关信息等以实现相应的功能。
8.1.4您可以选择不向公司提供您的某些信息，或者根据产品设置取消公司收集某些信息的权利，但因此可能会导致相关服务功能无法实现。
8.1.5公司将会尽其商业上的合理努力保障您在本软件及服务中的数据存储安全，但是，公司并不能就此提供完全保证，包括但不限于以下情形：
（1）公司不对由于非公司原因造成的您在本软件和本服务中相关数据的删除或储存失败负责。
（2）公司有权根据实际情况自行决定单个用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您应自行备份存储在本软件和本服务中的数据、信息或与本软件和本服务相关的数据、信息。
（3）如果您停止使用本软件及本服务，或因您违反法律法规或本协议而被取消或终止使用本服务，公司有权从服务器上永久地删除您的数据。您的服务停止、终止或取消后，公司没有义务向您返还任何数据。
8.1.6用户在使用本软件及服务时，须自行承担如下来自公司不可掌控的风险内容，包括但不限于：
（1）由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；
（2）用户必须选择与所安装终端设备相匹配的软件版本，否则，由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；
（3）用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；
（4）用户发布的内容被他人转发、分享、复制、修改或作其他用途，因此等传播可能带来的风险和责任；
（5）由于无线网络信号不稳定、无线网络带宽小等原因，所引起的本软件登录失败、资料同步不完整、页面打开速度慢等风险；
8.1.7本服务可能会向您提供一些与地理位置、个性签名等信息相关的基于非好友用户之间的交友、拓展好友的功能，您使用这些功能即表示您同意本服务获取、使用您的地理位置、个性签名等信息。同时，您理解并同意：在前述相关功能中，相关信息的发布由用户自行发布，并自行确保其合法、健康、真实以及自行承担相关法律责任；您应自行通过各种手段认真核实相关用户及其发布信息的合法性、真实性，若您与其他用户涉及线下见面、约会或交友等各种实体活动的，要注意保护好自己的人身、财产安全；同时，公司在前述相关功能中，仅提供技术支持和平台服务，基于互联网虚拟的特性，公司无法核实相关用户及发布信息的真实性、合法性，也无法向您提供任何保证。若由于前述相关功能，导致您在线上、线下有任何人身、财产损失的，您同意自行承担全部责任，与公司无关，公司不承担任何责任。
8.2第三方产品和服务
8.2.1您在使用本软件第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。公司和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。
8.2.2因用户使用本软件或要求公司提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供，公司不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与公司无关，公司不承担任何责任。
8.2.3 您理解并同意，公司有权决定将本软件作商业用途，包括但不限于开发、使用本软件的部分服务为第三方作推广等，公司承诺在推广过程中严格按照本协议约定保护您的个人信息，同时您亦可以根据系统设置选择屏蔽、拒绝接收相关推广信息。
8.3信息内容规范
8.3.1本条所述信息内容是指用户使用本软件及服务过程中所制作、复制、发布、传播的任何内容，包括但不限于ShunFeng账号的头像、昵称、个性签名等注册信息，或发送的文字、语音、图片、视频、表情和相关链接页面等信息，以及其他使用ShunFeng账号或本软件及服务所产生的内容。
8.3.2您理解并同意，ShunFeng一直致力于为用户提供文明健康、规范有序的网络环境，您不得利用ShunFeng账号或功能账号或本软件及服务制作、复制、发布、传播如下干扰ShunFeng正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：
8.3.2.1 发布、传送、传播、储存违反国家法律法规禁止的包括但不限于以下内容：
（1）反对宪法所确定的基本原则的；
（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
（3）损害国家荣誉和利益的；
（4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
（5）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；
（6）煽动民族仇恨、民族歧视，破坏民族团结的；
（7）破坏国家宗教政策，宣扬邪教和封建迷信的；
（8）散布谣言，扰乱社会秩序，破坏社会稳定的；
（9）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
（10）侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；
（11）使用夸张标题，内容与标题严重不符的；
（12）炒作绯闻、丑闻、劣迹等的；
（13）不当评述自然灾害、重大事故等灾难的；
（14）带有性暗示、性挑逗等易使人产生性联想的；
（15）展现血腥、惊悚、残忍等致人身心不适的；
（16）煽动人群歧视、地域歧视等的；
（17）宣扬低俗、庸俗、媚俗内容的；
（18）可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；
（19）侵害未成年人合法权益或者损害未成年人身心健康的内容；
（20）其他对网络生态造成不良影响的内容。
（21）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；
（22）以非法民间组织名义活动的；
（23）不符合《即时通信工具公众信息服务发展管理暂行规定》及遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；
（24）法律、行政法规禁止的其他内容的。
8.4软件使用规范
除非法律允许或公司书面许可，您使用本软件过程中不得从事下列行为：
8.4.1.1 删除本软件及其副本上关于著作权的信息；
8.4.1.2 对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；
8.4.1.3 对公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
8.4.1.4 对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用未经公司授权或许可的任何插件、外挂、系统或第三方工具对ShunFeng软件及相关服务的正常运行进行干扰、破坏、修改或施加其他影响。
8.4.1.5 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
8.4.1.6 通过非公司开发、授权的第三方软件、插件、外挂、系统，登录或使用公司软件及服务，或制作、发布、传播上述工具；
8.4.1.7 自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；
8.4.1.8 其他未经公司明示授权的行为。
8.5服务运营规范
除非法律允许或公司书面许可，您使用本服务过程中不得从事下列行为：
8.5.1 提交、发布虚假信息，或冒充、利用他人名义的；
8.5.2 诱导其他用户点击链接页面或分享信息的；
8.5.3 虚构事实、隐瞒真相以误导、欺骗他人的；
8.5.4 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利；
8.5.5 未经公司书面许可利用ShunFeng账号、功能账号和任何功能，以及第三方运营平台进行推广或互相推广的；
8.5.6 利用ShunFeng账号或功能账号或本软件及服务从事任何违法犯罪活动的；
8.5.7 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
8.5.8 其他违反法律法规规定、侵犯其他用户合法权益、干扰产品正常运营或公司未明示授权的行为。
8.6平台健康和用户体验
本软件和本服务的目的是为了好友之间、用户之间进行各种正常的沟通、交流，所以您不得从事包括但不限于以下任何行为，也不得为以下任何行为提供便利：
（1）进行任何超出本软件和本服务设定目的的非正常沟通、交流等行为，包括但不限于：打招呼等行为的频次、时间、地域等超出正常范围；向其他用户以各种形式发送、分享任何用户、公司或机构的商业或非商业信息（比如利诱用户分享，胁迫、煽动用户分享等）。
（2）出于超出本软件和本服务设定目的的好友或用户之间的非正常沟通、交流等目的（包括但不限于为发送广告、垃圾、骚扰或违法违规等信息的目的），通过自己添加或诱导他人添加等任何方式使自己与其他用户形成好友关系（好友关系包括但不限于单向好友关系和双向好友关系，下同）。
您理解并同意：若您违反前述约定，公司有权不经您同意而直接解除您的好友关系；若您的单向或双向好友（简称“违规用户”）违反前述约定，公司有权按照本协议、相关协议或相关法律法规等，对违规用户进行处理，由此可能会影响您与违规用户之间的信息交流、好友关系等以及您对本服务的使用，这是公司为了维护健康良好的网络环境而采取的必要措施，若由于公司按照前述约定对违规用户采取措施而对您产生影响或任何损失的，您会自行承担相关损失。
（3）通过非人工或非手动方式（比如外挂软件、程序等）发送信息。
（4）发送各种形式的广告、推广、垃圾、骚扰或违法违规等信息。
（5）通过非人工或非手动方式（比如外挂软件、程序等）进行账号登录、加好友、留言、发帖、发相片等非正常的操作行为。
（6）通过本软件和本服务向好友或其他用户批量发送信息或发送非正常信息。
（7）其他可能影响平台健康、用户交流、用户体验的行为。
8.7平台安全内容
您不得从事包括但不限于以下任何行为，也不得为以下任何行为提供便利：
（1）传播虚假中奖信息、钓鱼欺诈信息、非法或虚假理财信息等非法、诈骗或虚假信息。
（2）传播包含病毒、木马等的文件、程序或相应制作教程等的内容、信息。
（3）其他危害公司、本软件或其他主体安全的内容、信息或行为。
8.8数据信息安全
为了保护数据安全，您不得从事包括但不限于以下行为，也不得为其他第三方提供便利：
（1）未经其他ShunFeng用户明确同意，或在未向其他ShunFeng用户如实披露数据用途、使用范围等相关信息的情形下收集、复制、存储、使用或传输其他ShunFeng用户数据，侵害其他ShunFeng用户合法权益。
（2）将其他ShunFeng用户ShunFeng号、昵称、邮箱地址等个人信息用于任何未经用户及公司授权的用途。
（3）企图进行反射查找、跟踪、关联、挖掘、获取用户ShunFeng号、邮箱地址等个人信息。
（4）通过各种程序、软件等抓取任何用户的信息或与本软件和本服务相关的任何信息、数据。
（5）未经公司授权使用任何第三方软件、插件、外挂、系统等查看、获取本软件和本服务中所包含的公司、公司合作伙伴或用户的任何相关信息、数据等内容。
（6）其他危害数据安全的行为。
8.9账号解封
若您申请自助解除封号的，应自行通过人工手动的方式按照公司指定流程、规则提交解封申请，您不得实施通过软件、程序等申请解封的行为，也不得提交虚假资料、相关信息等。
8.10对自己行为负责
您充分了解并同意，您必须为自己注册账号下的一切行为负责，包括您所发表的任何内容、评论及分享等行为，以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。公司无法且不会对因前述风险而导致的任何损失或损害承担责任。
8.11用户发送、传播的内容与投诉处理
8.11.1如果您发送或传播的内容违法违规或侵犯他人权利的，您同意公司有权进行独立判断并采取删除、屏蔽或断开链接等措施。
8.11.2如您被他人投诉或您投诉他人，公司有权将争议中相关方的主体、联系方式、投诉相关内容等必要信息提供给相关当事方或相关部门，以便及时解决投诉纠纷，保护各方合法权益。
8.12违约处理
8.12.1如果公司发现或收到他人举报或投诉用户违反本协议约定的，公司有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规主体相关账号处以包括但不限于警告、限制或禁止使用部分或全部功能、账号封禁直至注销的处罚，并公告处理结果。
8.12.2您理解并同意，公司有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。
8.12.3您应自行对因使用本服务而产生或存储在本服务中的数据（包括但不限于好友信息、图片、个人资料信息、照片等），在本服务之外采取合理、安全的备份。若公司根据本协议对您采取永久封号等措施的，对于您的与本服务相关的全部数据或您存储在本服务中的全部数据、信息等，公司有权将该等数据全部予以删除，相应后果您应自行承担。
8.12.4您理解并同意，因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行处理并承担可能因此产生的全部法律责任。因您的违法或违约等行为导致公司及其关联方、控制公司、继承公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿公司遭受的全部损失。
九、知识产权
9.1公司是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受法律法规和相应的国际条约保护，公司享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
9.2 未经公司或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。
9.3 您使用本软件及服务过程中上传、发布的全部内容，均不会因为上传、发布行为发生知识产权、肖像权等权利的转移。与此同时，您理解并同意公司为实现产品目的，对您发布的特定公开非保密内容（如“视频图片”、“自拍表情”等）在法律允许的范围内进行使用，包括但不限于予以存储、向有关用户播放、供有关用户获取及再次使用等。
十、广告
10.1 公司依照法律规定履行广告及推广相关义务，您应当自行判断该广告或推广信息的真实性和可靠性并为自己的判断行为负责。除法律法规明确规定外，您因该广告或推广信息进行的购买、交易或因前述内容遭受的损害或损失，您应自行承担，公司不予承担责任。
十一、终端安全责任
11.1 您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。
11.2 您不得制作、发布、使用、传播用于窃取ShunFeng账号、功能账号及他人个人信息、财产的恶意程序。
11.3 维护软件安全与正常使用是公司和您的共同责任，公司将按照行业标准合理审慎地采取必要技术措施保护您的终端设备信息和数据安全，但是您承认和同意公司并不能就此提供完全保证。
11.4 在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意公司有关防范诈骗犯罪的提示。
11.5 我们不建议在某些存在重大受伤或事故风险的活动（例如驾驶）中使用服务。您同意不在这些活动中使用我们的服务，并确认任何此类使用均违反本条款。您进一步确认并同意，此类使用风险由您自行承担，我们对由此造成的任何性质的损害概不负责。
十二、第三方软件或技术
12.1 本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。
12.2 本软件如果使用了第三方的软件或技术，公司将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包、或通过开源软件页面等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。
12.3前述通过各种形式展现的相关协议或其它文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。
如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求公司给予协助，您应当自行承担法律责任。
12.4如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，公司不承担任何责任。公司不对第三方软件或技术提供客服支持，若您需要获取支持，请与第三方联系。
十三、不可抗力及其他免责事由
13.1 您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，公司将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失，公司在法律允许的范围内免责。
13.2 在法律允许的范围内，公司对以下情形导致的服务中断或受阻不承担责任：
（1）用户的电脑软件、系统、硬件、通信线路或受其他不可抗力因素影响，导致网络环境异常或服务故障。
（2）用户操作不当或用户通过非公司授权的方式使用本服务。
（3）程序版本过时、设备的老化或其兼容性问题。
（4）其他公司无法控制或合理预见的情形。
13.3 您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，公司不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：
（1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息。
（2）遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失。
（3）其他因网络信息或用户行为引起的风险。
13.4 公司依据本协议约定获得处理违法违规内容的权利，该权利不构成公司的义务或承诺，公司不能保证及时发现违法行为或进行相应处理。
13.5 在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。涉及财产操作的，请一定先核实对方身份，并请经常留意公司有关防范诈骗犯罪的提示。
13.6 您在使用本服务过程中所发布的内容有可能会被第三方评论、转发、复制、修改或作其他用途，从而脱离您的预期和控制，您必须充分意识此类风险的存在，公司对由此产生的纠纷不予负责。
十四、其他
14.1 您使用本软件和本服务即视为您已阅读并同意受本协议的约束。公司有权在必要时修改本协议条款。您可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。
14.2 本协议签订地为中华人民共和国香港特别行政区。
14.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国香港特别行政区法律（不包括冲突法）。
14.4 若您和公司之间发生任何纠纷或争议，双方应尽量友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
14.5 本协议中的标题仅为方便阅读而设，并不影响本协议中任何规定的含义或解释。
14.6 本协议可能存在包括中文、英文在内的多种语言的版本。
14.7 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
14.8 您和公司均是独立的主体，在任何情况下本协议不构成公司对您的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。
（正文完）
顺峰互动
        </pre>
    </div>
</template>

<script>
export default {
	name      : 'ServiceAgreementPc',
	components: {

	},

	data() {
		return {
            
		};
	},

	mounted() {
		window.scrollTo(0, 0);
	}
}
</script>

<style lang="less" scoped>
.sa_container {
	width: 100%;
	min-height: 100vh;
	box-sizing: border-box;
	padding: 100px 24px 60px;
	position: relative;

	.title {
		position: static;
		width: 100%;
		max-width: var(--com-base-container-w);
		height: auto;
		line-height: 1.5;
		margin: 0 auto 40px;
		font-family: var(--com-number-coin-fm-B) !important;
		font-size: var(--com-base-fz-32);
		color: #333;
		text-align: center;
	}

	.content {
		display: block;
		position: static;
		width: 100%;
		max-width: var(--com-base-container-w);
		height: auto;
		line-height: 2;
		margin: 0 auto;
		overflow: visible;
		font-family: inherit;
		font-size: var(--com-base-fz-14);
		color: #333;
		white-space: pre-wrap;
		word-break: break-word;
		overflow-wrap: anywhere;
	}
}

@media screen and (max-width: 768px) {
	.sa_container {
		padding: 64px 16px 36px;

		.title {
			margin-bottom: 18px;
			font-size: 28px;
			line-height: 1.4;
		}

		.content {
			font-size: 24px;
			line-height: 1.8;
		}
	}
}
</style>
